import { type EventCallable, createEvent, sample } from 'effector'

import { POLLING_INTERVAL_IN_MS } from './constants'

export function createPollingModel(
  event: EventCallable<void>,
  pollingInterval = POLLING_INTERVAL_IN_MS,
) {
  const pollingStarted = createEvent()
  const pollingStopped = createEvent()

  let intervalId: ReturnType<typeof setInterval> | null = null

  sample({
    clock: pollingStarted,
    fn: () => {
      if (intervalId === null) {
        intervalId = setInterval(() => {
          event()
        }, pollingInterval)
      }
    },
  })

  sample({
    clock: pollingStopped,
    fn: () => {
      if (intervalId !== null) {
        clearInterval(intervalId)
        intervalId = null
      }
    },
  })

  return {
    startPolling: pollingStarted,
    stopPolling: pollingStopped,
  }
}
